<template>
    <div id="my-schedule-Modal"
         class="overflow-auto">
      <b-table head-variant="light"
               :fields="fields"
               id="my-table"
               :items="items"
               :per-page="perPage"
               :current-page="currentPage"
               small
               ref="selectableTable"
               class="mb-0"
               hover
               outlineless
               borderless
               @row-clicked="onRowClicked"
               align="center">
        <!-- Define a scoped slot for the 'selected' column -->
        <template v-slot:cell(selected)="data">
          <!-- selected 아이콘 추가 -->
          <span aria-hidden="true"
                v-if="data.item.selected || data.item.show"
                :class="{ 'text-danger font-weight-bold': data.item.show }">
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="16"
                 height="16"
                 viewBox="0 0 16 16"
                 fill="none">
              <rect x="0.5"
                    y="0.5"
                    width="15"
                    height="15"
                    rx="3.5"
                    fill="#1755CC"/>
              <path d="M5 8L7 10L11 6"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"/>
              <rect x="0.5"
                    y="0.5"
                    width="15"
                    height="15"
                    rx="3.5"
                    stroke="#1755CC"/>
            </svg>
          </span>
          <!-- not selected 아이콘 추가 -->
          <span aria-hidden="true"
                v-else>
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="16"
                 height="16"
                 viewBox="0 0 16 16"
                 fill="none">
              <g clip-path="url(#clip0_939_25212)">
                <rect x="0.5"
                      y="0.5"
                      width="15"
                      height="15"
                      rx="3.5"
                      fill="white"
                      stroke="#C4C4CD"/>
              </g>
              <defs>
                <clipPath id="clip0_939_25212">
                  <rect width="16"
                        height="16"
                        rx="4"
                        fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="sr-only"
                v-if="data.item.selected || data.item.show">Selected</span>
          <span class="sr-only"
                v-else>Not selected</span>
        </template>
      </b-table>
      <!-- navigation arrows -->
      <b-icon class="h1 arrow arrow-left"
              icon="chevron-left"
              variant="secondary"
              @click="goLeft"
              v-if="currentPage > 1"></b-icon>
      <b-icon class="h1 arrow arrow-right"
              icon="chevron-right"
              variant="secondary"
              @click="goRight"
              v-if="currentPage < maxPage"></b-icon>
      <!-- /navigation arrows -->
      <b-pagination v-if="false"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    align="center"></b-pagination>
    </div>
  </template>
  <script>
  export default {
    props: {
      tableType: String,
      selectType: String,
      selectedValues: Array,
      keyword: String,
      notForShowValues: Array,
      list: null,
    },
    watch: {
      items: {
        deep: true,
        handler() {
  
        },
      },
    },
    computed: {
      typeOptions() {
        return this.$store.getters['mySchedule/typeOptions']
      },
      maxPage() {
        return this.rows / this.perPage;
      },
      rows() {
        return this.total;
      },
      fields() {
        let returnField = []
        switch (this.tableType) {
          case "mySchedule":
            returnField = [
              {
                key: "selected",
                label: "",
                thClass: ["text-center"],
                class: ["text-center", "align-middle", "columnRate3"]
              },
              {
                key: "type",
                label: "Type",
                class: ["text-center", "align-middle", "columnRate3"]
              },
              {
                key: "myScheduleId",
                label: "My Schedule ID",
                class: ["text-center", "align-middle", "columnRate20"]
              },
              {
                key: "status",
                label: "Status",
                class: ["text-center", "align-middle", "columnRate15", "custom-style"],
              },
              {
                key: "title",
                label: "Title",
                thClass: ["text-center", "columnRate60"],
                tdClass: ["text-left", "align-middle", "custom-style", "columnRate60"]
  
              }
            ];
            return returnField;

          default:
            return "c";
        }
      },
    },
    data() {
      return {
        seletedValues: [],
        perPage: 10,
        currentPage: 1,
        items: [],
        total: 0,
        selected: [],
        serial: null,
      };
    },
    methods: {
      goLeft() {
        this.currentPage = this.currentPage - 1;
      },
      goRight() {
        this.currentPage = this.currentPage + 1;
      },
  
      onRowClicked(item) {
        if (item.show) return;
        if (this.selectType == 'single' && item.selected != true) {
          this.items.forEach(item => item.selected = false)
        }
        item.selected = !item.selected;
      },
      reformatState(strStatus) {
        let arrStrStatus = strStatus.split("_");
        let result = '';
        for (let i in arrStrStatus) {
          let str = arrStrStatus[i]
          result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }
        return result
      },
      returnSelectedList() {
        this.selected = this.items.filter(item => item.selected === true);
        let selectedList = [];
        selectedList = this.selected;
        this.$emit("set-result", selectedList, this.list);
      },
      clearSelectedselectedes() {
        this.items.forEach(item => {
          item.selected = false;
        });
      },
      async retreiveData() {
        switch (this.tableType) {
          case "mySchedule":
            await this.retreiveMySchedule();
            this.items = this.items.map(item => {
              if (this.selectedValues.some(selectedItem => selectedItem.myScheduleId === item.myScheduleId)) {
                return { ...item, selected: true };
              } else {
                return { ...item, selected: false };
              }
            });
            break;
          default:
            break;
        }
        // this.items = await this.filterSelectedValues();
      },
      async retreiveMySchedule() {
        this.currentPage = 1;
        let params = {};
        if (this.keyword != '') {
          params.keyword = this.keyword;
        }
        params.pageSize = 0;
  
        // Load chats
        try {
          this.loading = true;
          let response = await axios.post('/chatter/retrieveMyScheduleList', params, {
            headers: {
              Authorization: accessToken()
            }
          });
          response.data.list.forEach((item) => {
            item.status = this.reformatState(item.status);
            if (item.selected == null) {
              item.selected = false;
            }
            if (item.type.length > 1) {
              item.type = item.type[0].toUpperCase() + item.type.slice(1).toLowerCase();
            }
          });
  
          if (this.items.length == 0) {
            this.items = response.data.list;
          } else {
            this.items.splice(0, this.items.length, ...response.data.list);
          }
          // Sort the list in descending order of serial number
          this.items.sort((a, b) => b.serial - a.serial);
  
          this.total = response.data.total;
        } catch (error) {
          this.loading = false;
          await this.showError(error);
        } finally {
          this.loading = false;
        }
      },
    },
    created() {
      this.clearSelectedselectedes();
      this.retreiveData();
    },
  };
  </script>
  
  <style>
  #my-schedule-Modal button {
      height: inherit;
  }
  
  #my-table {
      max-width: 100%;
      max-height: 100%;
      font-size: 1em;
      user-select: none;
  }
  
  .columnRate2 {
      width: 2%;
  }
  
  .columnRate3 {
      width: 3%;
  }
  
  .columnRate10 {
      width: 7%;
  }
  
  .columnRate15 {
      width: 15%;
  }
  
  .columnRate20 {
      width: 20%;
  }
  
  .columnRate25 {
      width: 25%;
  }
  
  .columnRate30 {
      width: 30%;
  }
  
  .columnRate40 {
      width: 40%;
  }
  
  .columnRate50 {
      width: 50%;
  }
  
  .columnRate60 {
      width: 60%;
  }
  
  .columnRate65 {
      width: 65%;
  }
  
  .arrow {
      position: absolute;
      top: 50%;
      opacity: .3;
  }
  
  .arrow:hover {
      opacity: 1;
      cursor: pointer;
  }
  
  .arrow-left {
      left: 0;
  }
  
  .arrow-right {
      right: 0;
  }
  
  .custom-style {
      max-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
  
  /* 신규 스타일 추가 */
  #my-schedule-Modal.overflow-auto {
      height: 440px !important;
      padding: 1px;
      font-family: 'NanumGothic';
  }
  
  #my-schedule-Modal.overflow-auto::-webkit-scrollbar {
      width: 16px;
      border-left: 10px solid transparent;
      background-clip: padding-box;
  }
  
  #my-schedule-Modal.overflow-auto::-webkit-scrollbar-track {
      width: 6px;
      background-color: #F6F6FA;
      border-left: 10px solid transparent;
      background-clip: padding-box;
  }
  
  #my-schedule-Modal.overflow-auto::-webkit-scrollbar-thumb {
      width: 100%;
      background-color: #C4C4CD;
      border-left: 10px solid transparent;
      background-clip: padding-box;
  }
  
  #my-schedule-Modal .table thead tr {
      background-color: transparent;
      box-shadow: 0 -1px 0 0 #DDDDE3,
      -1px 0 0 0 #DDDDE3,
      1px 0 0 0 #DDDDE3;
      border-radius: 10px 10px 0 0;
      border: none;
  }
  
  #my-schedule-Modal .table .thead-light th {
      padding: 0.666rem;
      background: #F6F6FA;
      color: #2E2E38;
      text-align: center;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  #my-schedule-Modal .table .thead-light th:first-child {
      border-radius: 10px 0 0 0;
  }
  
  #my-schedule-Modal .table .thead-light th:last-child {
      border-radius: 0 10px 0 0;
  }
  
  #my-schedule-Modal .table tbody {
      box-shadow: 0 0 0 1px #DDDDE3;
      border-radius: 0 0 10px 10px;
  }
  
  #my-schedule-Modal .table tbody tr {
      box-shadow: 0 1px 0 0 #DDDDE3;
  }
  
  #my-schedule-Modal .table tbody tr:last-child {
      box-shadow: none;
      border-radius: 0 0 10px 10px;
  }
  
  #my-schedule-Modal .table tbody td {
      padding: 0.666rem;
      color: #2E2E38;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
  }
  </style>
  